// extracted by mini-css-extract-plugin
module.exports = {"engineeringlead":"EmployeeTitle_engineeringlead__fl6CT","teamlead":"EmployeeTitle_teamlead__2paqd","techlead":"EmployeeTitle_techlead__2C54R"};